import { useMemo } from 'react';
import { CURRENCIES, useMoney } from '../currency';
import { Dropdown, type DropdownOption } from './Dropdown';

type Currency = (typeof CURRENCIES)[number];

/** Symbol měny jako „ukazatel" v přepínači. Neznámý kód ukáže sám sebe. */
const CURRENCY_SYMBOL: Record<string, string> = {
  CZK: 'Kč',
  EUR: '€',
  PLN: 'zł',
};

function CurrencyMark({ code }: { code: Currency }) {
  return <span className="cur-mark">{CURRENCY_SYMBOL[code] ?? code}</span>;
}

/** Přepínač zobrazovací měny (CZK/EUR/PLN). Ceny se přepočítají orientačně. */
export function CurrencySwitcher() {
  const { currency, setCurrency } = useMoney();
  const options = useMemo<DropdownOption<Currency>[]>(
    () =>
      CURRENCIES.map((code) => ({
        value: code,
        label: code,
        icon: <CurrencyMark code={code} />,
      })),
    [],
  );
  return (
    <Dropdown
      className="dropdown--currency"
      ariaLabel="Měna"
      value={currency}
      options={options}
      onChange={setCurrency}
    />
  );
}
